<template>
	<div>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
			<h1 class="h3 mb-0 text-gray-800">{{view_nome}}</h1>
			<div>
				<pdfBtn 
					:filter="string_filter" 
					type="datatable" 
					title="denuncias"
					datatable="denuncia"
					:external="false"
					:data_head="data_head" 
					:data_body="data_body" 
				/>
			</div>
		</div>
		
		<alert :type="alert.type" :mensagem="alert.msg" />
		<filtros :filter_data="filter_data" @filtrar="filtrar" />
		<priority />

		<div class="row">
			<table class="table table-striped table-hover table-sm table-responsive-xl">
				<thead align="center">
					<th @click="orderBy('id')"         >ID         <font-awesome-icon v-if="direction.by == 'id'"         :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('protocolo')"  >PROTOCOLO  <font-awesome-icon v-if="direction.by == 'protocolo'"  :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('data')"       >Data       <font-awesome-icon v-if="direction.by == 'data'"       :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('hora')"       >Hora       <font-awesome-icon v-if="direction.by == 'hora'"       :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('origem')"     >Origem     <font-awesome-icon v-if="direction.by == 'origem'"     :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('prioridade')" >Prioridade <font-awesome-icon v-if="direction.by == 'prioridade'" :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('status_id')"  >Status     <font-awesome-icon v-if="direction.by == 'status_id'"  :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('resumo')"     >Resumo     <font-awesome-icon v-if="direction.by == 'resumo'"     :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('unidade_id')" >Unidade    <font-awesome-icon v-if="direction.by == 'unidade_id'" :icon="order_icon" size="xs" /></th>

					<th @click="orderBy('complemento_count')">
						<font-awesome-icon icon="file-signature" title="Complementos" class="info" />
						<font-awesome-icon v-if="direction.by == 'complemento_count'" :icon="order_icon" size="xs" />
					</th>
					<th></th>
					<th></th>
				</thead>

				<transition mode="out-in" name="leftIn">
					<tbody v-if="denuncias" align="center">
						<tr v-for="(denuncia, index) in denuncias.result.data" :key="index" :class="closed_den(denuncia.conclusao_id)">
							<td>{{ denuncia.id }}</td>
							<td>{{ denuncia.protocolo }}</td>
							<td>{{ denuncia.created_at | moment("DD/MM/YYYY") }}</td>
							<td>{{ convert_hor(denuncia.created_at) | moment("HH:mm:ss") }}</td>
							<td>{{ Phone(denuncia.origem) }}</td>
							<td><font-awesome-icon icon="flag" :class="priority_color(denuncia.nota_interna.prioridade)" /></td>
							<td>{{ denuncia.nota_interna.status.nome }}</td>
							<td>{{ denuncia.nota_interna.resumo }}</td>
							<td>{{ get_unidade_name(denuncia.nota_interna.unidade_id) }}</td>
							<td>{{ (denuncia.complemento_count) ? denuncia.complemento_count : '' }}</td>
							<td><font-awesome-icon icon="eye" class="info pointer" @click="view(denuncia)" /></td>
							<td v-if="is_super_adm()"><font-awesome-icon icon="paperclip" class="info pointer" @click="audio_down(denuncia.gravacao_id)" /></td>
						</tr>

					</tbody>
					<Loading v-else />
				</transition>
			</table>
		</div>

		<controls :data="constrol_data" @refresh="navigate"  @alert="show_alert" />

		
		<encerramento :denuncia="den_to_close" @alert="show_alert" />
		<modal :denuncia="modal_data" @alert="show_alert" @close_den="close_den"/>
	</div>
</template>

<script>
	import api          from "@/mixins/api.js"
	import replace      from "@/mixins/replace.js"
	import filtros      from "@/components/Tools/Filtro.vue"
	import alert        from "@/components/Tools/alert.vue"
	import modal        from "@/components/Modal/Denuncia/Denuncia"
	import encerramento from "@/components/Modal/Denuncia/Encerramento"
	import controls 	from "@/components/Tools/Table_Control.vue"
	import priority 	from "@/components/Tools/record_priority.vue"
	import pdfBtn   from "@/components/Tools/Pdf.vue"

	export default {
		name: "Denuncias",
		mixins: [api, replace],
		components: { controls, filtros, modal, priority, alert, encerramento, pdfBtn},

		data() { return {
			den_to_close: null,
			denuncias: {nota_interna: {resumo: ""}},
			constrol_data: {},
			modal_data: {},

			looping: null,
			timestamps: true,
			unidades:{},
			alert: { type: "", msg: "" },
			direction: { order: "desc", by: "id" },

			pagination: "10?",
			string_filter: "",

			filter_data: [
				{ name: "id",         label: "ID",        type: "text",   data_get: ""},
				{ name: "data", 	  label: "Data",      type: "date",   data_get: ""},
				{ name: "origem" ,    label: "Origem",    type: "phone",  data_get: ""},
				{ name: "protocolo",  label: "Protocolo", type: "text",   data_get: ""}
				
			],
			data_head: ["PROTOCOLO", "DATA", "HORA", "ORIGEM", "PRIORIDADE", "STATUS", "RESUMO", "UNIDADE"],
			data_body: ["protocolo", "data", "hora", "origem", "prioridade", "status_id", "resumo", "unidade_id"]
		}},

		created() {
			if ( this.is_super_adm){ 
				this.filter_data.push({ name: "unidade",  label: "Unidade", type: "select",   data_get: "Unidade"})
			}
			this.get_unidades();
			this.get_data();
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down"
			},

			view_nome(){
				return ( this.$store.state.config_view_menu.denuncia_nome )
			},
		},

		methods: {

			is_super_adm() {
				if(this.$store.state.user.type === 3){
					return true
				}else{
					return false
				}
				
			},

			async get_unidades() {
				this.unidades = await this.GET("Unidade")
			},

			get_unidade_name(payload) {
				if(this.unidades.result){
					for (var i = 0; i <= this.unidades.result.length -1; i++) {
						if ( this.unidades.result[i].id == payload){
							return this.unidades.result[i].nome
						}
					}
				}
			},

			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc'
				}

				else this.direction.by = payload
				this.get_data()
			},

			filtrar(payload) {
				this.string_filter = payload
				this.get_data()
			},

			async get_data() {
				this.denuncias = null
				var paginacao_unidade
				if ( !this.is_super_adm ){
					paginacao_unidade = `&unidade=${this.$store.state.user.unidade_id}`
				}else{
					paginacao_unidade = ""
				}				

				this.denuncias = await this.GET("Denuncia", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}${paginacao_unidade}`)

				this.constrol_data = {
					current_page: this.denuncias.result.current_page,
					last_page:    this.denuncias.result.last_page,
					per_page:     this.denuncias.result.per_page,
					total:        this.denuncias.result.total,
				}

				if (this.timestamps) this.refresh()
				else clearTimeout(this.looping)
			},

			refresh() {
				clearTimeout(this.looping)
				this.looping = setTimeout( () => this.get_data(), 80000)
				//this.string_filter = ""
			},

			navigate(payload) {
				this.pagination = payload
				this.get_data()
			},

			view(payload) {
				var aux = this.GET("Denuncia", payload.id)
				this.modal_data = payload
				$("#modal-denuncia").modal('show')
			},

			async audio_down(payload){
				var respota = await this.GET("Audio/download", payload)
				var nome_audio = payload + '.wav'
				var fileURL=window.URL.createObjectURL(new Blob([respota]));
				var fileLink=document.createElement('a');
				fileLink.href=respota;
				fileLink.setAttribute('download', nome_audio);
				document.body.appendChild(fileLink);
				fileLink.click();
			},

			show_alert(payload) {
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger"
				this.alert.msg  = payload.result
				$("#modal-denuncia").modal('hide')
				this.get_data()
				$("#app-alert").show()
				setTimeout(() => $("#app-alert").hide(), 3000 )
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

			close_den(payload) {
				this.den_to_close = payload
				$("#modal-enc-processo").modal()
                $("#modal-denuncia").modal('hide')
			},

			closed_den(payload) {
				return ( payload ) ? "table-danger" : ""
			},
		},
	}
</script>